import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'carts-to-convert',
    name: 'carts-to-convert',
    component: () => import('./carts-to-convert.vue'),
    props: false,
  },
];
